import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { TRUST } from "@/data";

export const About = () => {
  return (
    <section id="about" data-testid="about-section" className="py-20 md:py-28 surface-b">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#E63946]">About Us</p>
          <h2 className="font-heading mt-3 text-3xl sm:text-4xl font-bold tracking-tight text-steel">
            Your local Buckinghamshire trade experts
          </h2>
          <p className="mt-5 text-gray-300 leading-relaxed">
            MJL Maintenance &amp; Locks Ltd is a local Buckinghamshire business providing
            locksmith services, property maintenance, home improvements, security upgrades,
            rubbish clearances, and bespoke installations.
          </p>
          <p className="mt-4 text-gray-300 leading-relaxed">
            With years of hands-on experience, we pride ourselves on delivering professional
            workmanship, honest pricing, and excellent customer service.
          </p>

          <div className="mt-8 grid grid-cols-2 gap-4">
            <div className="rounded-xl card-grey elev border border-white/10 p-5">
              <p className="font-heading text-3xl font-extrabold text-[#E63946]">100%</p>
              <p className="text-sm text-gray-400 mt-1">Fully insured work</p>
            </div>
            <div className="rounded-xl card-grey elev border border-white/10 p-5">
              <p className="font-heading text-3xl font-extrabold text-[#E63946]">Free</p>
              <p className="text-sm text-gray-400 mt-1">No-obligation quotes</p>
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="rounded-2xl card-grey elev border border-white/10 p-8"
        >
          <h3 className="font-heading text-xl font-semibold mb-6 text-white">Why choose us</h3>
          <ul className="space-y-4">
            {TRUST.map((t) => (
              <li key={t} data-testid={`trust-item-${t}`} className="flex items-center gap-3">
                <span className="flex items-center justify-center w-7 h-7 rounded-full bg-[#E63946]/15 text-[#E63946] shrink-0 ring-1 ring-[#E63946]/20">
                  <Check className="w-4 h-4" strokeWidth={3} />
                </span>
                <span className="text-gray-200 font-medium">{t}</span>
              </li>
            ))}
          </ul>
        </motion.div>
      </div>
    </section>
  );
};
